export type CaptureError = (error: unknown, context?: string) => void;

export function attachGlobalErrorCapture(captureError: CaptureError): () => void {
  if (typeof window === 'undefined') return () => {};

  const onError = (event: ErrorEvent) => {
    captureError(event.error ?? event.message, 'window.error');
  };
  const onRejection = (event: PromiseRejectionEvent) => {
    captureError(event.reason, 'window.unhandledrejection');
  };

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);

  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
